import { toast } from "react-toastify";
import { axiosUnauthInstance } from "../../service/API";
import { setDeveloperListByRoleSkills, setFaqsListByRoleSkills, setFeaturedList, setFeaturedLoading } from "../slice/homeSlice";
import { setSelectedSkill } from "../slice/commonSlice";

export const fetchFeaturedDeveloper = () => {
    return async (dispatch) => {
        try {
            const { status, data } = await axiosUnauthInstance.get('/developer/?featured=1');
            const { results } = data || {};
            if (status === 200) {
                dispatch(setFeaturedList(results))
                dispatch(setFeaturedLoading(false))
            }
            return status;
        } catch (error) {
            console.log(error);
            toast.error(error.message);
        }
    }
}
export const fetchDeveloperByRoleOrSkill = (params) => {
    return async (dispatch) => {
        try {
            const { status, data } = await axiosUnauthInstance.get(`/developer/?${params}&admin=1`);
            const { results } = data || {};
            if (status === 200) {
                dispatch(setDeveloperListByRoleSkills(results))
            }
            return status;
        } catch (error) {
            console.log(error);
            toast.error(error.message);
        }
    }
}

export const fetchFaqsByRoleOrSkill = (params) => {
    return async (dispatch) => {
        try {
            const { status, data } = await axiosUnauthInstance.get(params);
        
            const { faqs, name } = data || {};
            if (status === 200) {
                dispatch(setFaqsListByRoleSkills(faqs));
                dispatch(setSelectedSkill(`${params.includes("skills/") ? `${name} developers` : `${name}`}`));
            }
            return status;
        } catch (error) {
            console.log(error);
            toast.error(error.message);
        }
    }
}
